import TextExplainer from './TextExplainer';

export default TextExplainer;
export { TextExplainer };
